import { FileType } from "ui/Scripts/source/models/enums";

export interface IDocumentRemoveItem {
    id: string;
    code: string;
    fileType: FileType;
}

export class DocumentRemoveItem implements IDocumentRemoveItem {
    id: string;
    code: string;
    fileType: FileType;

    constructor();
    constructor(obj: IDocumentRemoveItem);
    constructor(obj?: any) {
        this.id = obj && obj.id || "";
        this.code = obj && obj.code || "";
        this.fileType = obj && obj.fileType || FileType.Unknown;
    }
}
